export default __webpack_public_path__ + "static/media/Monument.1eeffe57.gif";